<template>
    <div class="modal fade" 
        :class="this.modalPosition" 
        :id="modalID" 
        :aria-labelledby="theModalLabel" 
        tabindex="-1"
        aria-hidden="true"
        @click.self="close">

        <div class="np-base-dialog modal-dialog modal-xl modal-dialog-centered w-100" :class="modalClass">
                <div class="modal-content shadow" style="min-height: 700px;">
                    <div class="modal-header border-0 p-4 pb-2">
                        <span class="col-sm-8 d-flex align-middle">
                            <svg class="icon"><use href="@/assets/images/icons/cog.svg#icon"></use></svg>
                            {{ $t("UI.settings.baseSettings") }}
                        </span>
                        <div class="d-flex justify-content-end flex-grow-1">
                            <button type="button" class="np-btn np-outline" data-bs-dismiss="modal" aria-label="Close">
                                <svg><use href="@/assets/images/icons/close3.svg#icon"></use></svg> 
                            </button>
                        </div>
                    </div>

                    <div class="modal-body d-flex ps-3 pe-3 pb-3">
                        <div class="row np-flex-1 m-0 pb-3">
                            <div class="col-3">
                                <div class="np-group np-tabs-column">
                                    <button class="np-btn mb-3" 
                                        :class = "this.activeTab == 'profile' ? 'np-btn-secondary active' : 'np-btn-outline'"
                                        @click="switchTab('profile')">
                                        <svg class="icon"><use href="@/assets/images/icons/team-user.svg#icon"></use></svg> {{ $t("UI.settings.profile") }}
                                    </button>

                                    <button class="np-btn mb-3" 
                                        :class = "this.activeTab == 'notifications' ? 'np-btn-secondary active' : 'np-btn-outline'"
                                        @click="switchTab('notifications')">
                                        <svg class="icon"><use href="@/assets/images/icons/notification.svg#icon"></use></svg> {{ $t("UI.settings.notifications") }}
                                    </button>

                                    <button class="np-btn mb-3" 
                                        :class = "this.activeTab == 'design' ? 'np-btn-secondary active' : 'np-btn-outline'"
                                        @click="switchTab('design')">
                                        <svg class="icon"><use href="@/assets/images/icons/design.svg#icon"></use></svg> {{ $t("UI.settings.security") }}
                                    </button>

                                    <button class="np-btn mb-3"
                                        :class = "this.activeTab == 'subscribe' ? 'np-btn-secondary active' : 'np-btn-outline'"
                                        @click="switchTab('subscribe')">
                                        <svg class="icon"><use href="@/assets/images/icons/ticket.svg#icon"></use></svg> {{ $t("UI.settings.design") }}
                                    </button>

                                    <button class="np-btn mb-3"
                                        :class = "this.activeTab == 'security' ? 'np-btn-secondary active' : 'np-btn-   '"
                                        @click="switchTab('security')">
                                        <img src="@/assets/images/dashboard/base-design-dark.svg"> {{ $t("UI.settings.design") }}
                                    </button>
                                </div>                            
                            </div>
                            <div class="col-9">                    
                                <div v-if="this.activeTab == 'profile'" class="np-panel h-100 p-2">
                                    <div class="np-panel-body p-4">                          
                                        <h3 class="np-header3 mb-2">{{ $t("UI.settings.profileSettings") }}</h3>
                                        <div class="row mt-4">
                                            <div class="col-3 mt-4">
                                                <CoverUploader
                                                    :initialImage="userStore.user?.imageFile"
                                                    :updateCover="updateCoverImage"
                                                    :removeCover="removeCoverImage"
                                                    @file-selected="handleCoverSelected"
                                                    :placeholder="$t('UI.settings.avatar')"
                                                />
                                            </div>
                                            <div class="col-9 mt-4">
                                                <span class="np-font-ml">
                                                    {{ userStore?.user?.first_name }} {{ userStore?.user?.last_name }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="row mt-4" v-if="userStore.user">
                                            <div class="col">
                                                <label for="basic-url" class="form-label">{{ $t('auth.firstname') }}</label>
                                                <div class="input-group">
                                                    <input type="text" class="form-control" v-model="userStore.user.first_name">
                                                </div>
                                            </div>  
                                            <div class="col">
                                                <label for="basic-url" class="form-label">{{ $t('auth.surname') }}</label>
                                                <div class="input-group">
                                                    <input type="text" class="form-control" v-model="userStore.user.last_name">
                                                </div>
                                            </div>  
                                        </div>                                     
                                        <div class="row mt-4" v-if="userStore.user">
                                            <div class="col">
                                                <label for="basic-url" class="form-label">{{ $t('UI.settings.email') }}</label>
                                                <div class="input-group">
                                                    <input type="text" class="form-control" v-model="userStore.user.mail" disabled>
                                                </div>
                                            </div>  
                                            <div class="col">
                                                <label for="basic-url" class="form-label">{{ $t('UI.settings.language') }}</label>
                                                <div class="input-group">
                                                    <select class="form-control" v-model="userStore.user.lang">
                                                        <option value="ru">RU</option>
                                                        <option value="en">EN</option>
                                                    </select>
                                                </div>
                                            </div>         
                                        </div>                                 
                                        <div class="row mt-4">
                                            <div class="col pt-2">
                                                <button class="np-btn np-link np-color-danger np-font-ml">
                                                    {{ $t("UI.settings.deleteAccount") }}
                                                </button>
                                            </div>  
                                        </div> 
                                        <div class="row mt-4">
                                            <div class="col pt-2">
                                                <button class="np-btn np-success-filled w-100" @click="doSaveSettings" :disabled="this.isLoading">
                                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.isLoading"></span>
                                                    {{ $t("UI.save") }}
                                                </button>                                                      
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="this.activeTab == 'notifications'" class="np-panel h-100 p-2">
                                    <div class="np-panel-body p-4">    
                                        <h3 class="np-header3 mb-2">{{ $t("UI.settings.notificationsSettings") }}</h3>

                                        <div class="row mt-4">
                                            <div class="col">
                                                <span class="np-font-s">Автоматически дублировать</span>
                                            </div>  
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col">
                                                <span class="np-font-s">Проекты</span>
                                            </div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col">
                                                <span class="np-font-ml mb-1">Уведомления от проектов</span>
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked>
                                                </div>                                                
                                            </div>
                                            <div class="col">
                                                <span class="np-font-ml mb-1">Уведомления от проектов</span>
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked>
                                                </div>                                                
                                            </div>                                            
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col">
                                                <span class="np-font-s">Задачи</span>
                                            </div>
                                        </div>
                                        <div class="row pt-2">
                                            <div class="col">
                                                <span class="np-font-ml mb-1">Уведомления от задач</span>
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked>
                                                </div>                                                
                                            </div>
                                            <div class="col">
                                                <span class="np-font-ml mb-1">Уведомления от задач</span>
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked>
                                                </div>                                                
                                            </div>                                            
                                        </div>                                        
                                        <div class="row mt-4">
                                            <div class="col">
                                                <span class="np-font-s">Мессенджер</span>
                                            </div>                                                                                                                                    
                                        </div> 
                                        <div class="row pt-2">
                                            <div class="col">
                                                <span class="np-font-ml mb-1">Уведомления от сообщений</span>
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked>
                                                </div>                                                
                                            </div>
                                            <div class="col">
                                                <span class="np-font-ml mb-1">Уведомления от сообщений</span>
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked>
                                                </div>                                                
                                            </div>                                            
                                        </div>                                        
                                    </div>
                                </div>                                

                                <div v-if="this.activeTab == 'security'" class="np-panel h-100 p-2">
                                    <PerfectScrollbar>
                                        <div class="np-panel-body">                                   
                                            <h3 class="dashboard-panel__title">{{ $t("UI.settings.authentication")}}</h3>

                                            <div class="settings-single-row mt-4 mb-3">
                                                <div class="cobalt-form-group">
                                                    <label for="basic-url" class="form-label">{{ $t('UI.settings.oldPassword') }}</label>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" v-model="password.old">
                                                    </div>
                                                </div>  
                                            </div>   

                                            <div class="settings-single-row mb-3">
                                                <div class="cobalt-form-group">
                                                    <label for="basic-url" class="form-label">{{ $t('UI.settings.newPassword') }}</label>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" v-model="password.new">
                                                    </div>
                                                </div>  
                                            </div>                                     

                                            <div class="settings-single-row mb-3">
                                                <div class="cobalt-form-group">
                                                    <label for="basic-url" class="form-label">{{ $t('UI.settings.newPasswordRetype') }}</label>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" v-model="password.new2">
                                                    </div>
                                                </div>  
                                            </div> 
                                            <div class="settings-single-rows">
                                                <p class="error_text" v-if="this.errorText">{{  this.errorText }}</p>
                                            </div> 
                                        </div>    
                                        <div class="dashboard-panel__footer mt-4">
                                            <button class="btn cobalt-blue-button" @click="doChangePassword" :disabled="this.isLoading">
                                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.isLoading"></span>
                                                {{ $t("UI.save") }}
                                            </button>                            
                                        </div>      
                                    </PerfectScrollbar>
                                </div>                                            
                            
                                <div v-if="this.activeTab == 'design'" class="np-panel h-100 p-2">
                                    <PerfectScrollbar>
                                        <div class="np-panel-body">                                   
                                            <h3 class="dashboard-panel__title">{{ $t("UI.settings.design")}}</h3>

                                            <div class="settings-single-row mt-4 mb-3">
                                                <div class="cobalt-form-group">
                                                    <div class="form-check form-switch">
                                                        <label class="form-check-label" for="flexSwitchCheckDefault">Hide covers in projects</label>
                                                        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault">
                                                    </div>
                                                </div>  
                                            </div>   

                                            <div class="settings-single-row mb-3">
                                                <div class="cobalt-form-group">
                                                    <label for="basic-url" class="form-label">Day starts from</label>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                                                    </div>
                                                </div>  
                                            </div>                                     

                                            <div class="settings-single-row mb-3">
                                                <div class="cobalt-form-group">
                                                    <label for="basic-url" class="form-label">Day end in</label>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                                                    </div>
                                                </div>  
                                            </div>  
                                        </div>    
                                        <div class="dashboard-panel__footer mt-4">
                                            <button class="btn cobalt-blue-button">{{ $t("UI.save") }}</button>                            
                                        </div>                                    
                                    </PerfectScrollbar>
                                </div>                                            
                            </div>
                        </div>                         
                    </div>

                    <!--
                    <div class="modal-footer p-3">
                        <button type="button" class="np-btn np-danger px-4 me-1"
                            data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
                        <button type="button" class="np-btn np-success-filled px-4" @click="updateUser()">{{ $t("UI.save") }}</button>
                    </div>                    
                    -->
                </div>
        </div>
    </div>
</template>

<script>
import { useUserStore } from '@/stores/userStore'
import { Modal } from "bootstrap"
import { ref } from 'vue'
import CoverUploader from "@/components/elements/CoverUploader.vue"

export default {
    components: {
        CoverUploader
    },
    props: { 
        modalID: {
            type: String,
            required: true
        },        
        modalSize: {
            type: String,
            default: ''
        },
        modalPosition: {
            type: String,
            default: ''
        }                  
    }, 
    data() {
        return { 
            theModal: null,
            theModalLabel: null,  
            activeTab: "profile",          
            password: {
                old: '',
                new: '',
                new2: ''
            },             
        }
    },    
    computed: {
        userStore() {
            return useUserStore()
        }
    },
    mounted: function () {
        var IdModal = '#' + this.$props.modalID
        this.theModalLabel = this.modalID + "Label"
        this.theModal = new Modal(IdModal, {backdrop: true})        
    },           
    methods: {
        switchTab(mode) {
            this.activeTab = mode
        },
        shows(companyId, projectInfo) {
            if (!projectInfo) {
                this.projectData = Object.assign({}, this.emptyProject)
            } else {
                this.projectData = Object.assign({}, projectInfo)
                this.projectData["uploadImage"] = null
            }
            
            if (companyId) {
                this.projectData.company_id = companyId
            }

            this.theModal.show()
        },
        hide() {
            this.theModal.hide()
        },
        async close() {
            this.$emit('closeModal')
        },
        async updateCoverImage(file) {
            const formData = new FormData()
            formData.append("image", file)
            formData.append("id", this.userStore.user.id)

            let result = await this.userStore.uploadAvatar(formData)
        },
        async removeCoverImage() {
            let result = await this.userStore.removeCover(this.userStore.user.id)
        },         
        async doSaveSettings() {
            let response = await this.userStore.saveSettings(this.userStore.user)
        }, 
    }
}
</script>

<style>
    .modal {
        backdrop-filter: blur(5px);
    }
</style>